import React from 'react';
import Moment from 'moment';
import { startCase } from 'lodash';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';

function RecurringAvailabilitiesList(props) {
  const { classes, recurringAvails, onDelete, isLoading } = props;

  return isLoading ? (
    <div className={classes.loading}>
      <CircularProgress />
    </div>
  ) : (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Provider</TableCell>
          <TableCell>Location</TableCell>
          <TableCell>Day</TableCell>
          <TableCell>Starts on</TableCell>
          <TableCell>Range</TableCell>
          <TableCell>Duration</TableCell>
          {/* <TableCell>Ends on</TableCell> */}
          <TableCell>Created On</TableCell>
          <TableCell />
        </TableRow>
      </TableHead>
      <TableBody>
        {recurringAvails.map(availability => (
          <TableRow key={availability.id}>
            <TableCell>{availability.providerName}</TableCell>
            <TableCell>{availability.providerLocation}</TableCell>
            <TableCell>{startCase(availability.dayOfWeek)}</TableCell>
            <TableCell>
              {Moment.utc(availability.startsOn).format('MM/DD/YYYY')}
            </TableCell>
            <TableCell>
              {`${Moment(availability.start).format('hh:mm A')} - ${Moment(
                availability.end
              ).format('hh:mm A')}`}
            </TableCell>
            <TableCell>{`${availability.durationWeeks} weeks`}</TableCell>
            {/* <TableCell>
              {Moment.utc(availability.end).format('MM/DD/YYYY')}
            </TableCell> */}
            <TableCell>
              {Moment(availability.createdAt).format('MM/DD/YYYY')}
            </TableCell>
            <TableCell>
              <IconButton onClick={() => onDelete(availability)}>
                <DeleteIcon />
              </IconButton>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export default RecurringAvailabilitiesList;
